// Locale-aware formatting + Croatian field helpers.
// USD→EUR rate is loaded from /api/rates/usd-eur on app start; falls back to 0.92.
import api from "./api";

let _rate = 0.92;
let _ratePromise = null;

export const initFxRate = () => {
  if (_ratePromise) return _ratePromise;
  _ratePromise = api.get("/rates/usd-eur").then((r) => {
    if (r?.data?.rate && r.data.rate > 0.5 && r.data.rate < 2.0) {
      _rate = r.data.rate;
    }
    return _rate;
  }).catch(() => _rate);
  return _ratePromise;
};

export const getUsdToEur = () => _rate;

export const currencyForLang = (lang) => ((lang || "en").startsWith("hr") ? "EUR" : "USD");

export const convertPrice = (usdAmount, lang) =>
  currencyForLang(lang) === "EUR" ? Number(usdAmount) * _rate : Number(usdAmount);

export const formatPrice = (usdAmount, lang) => {
  const currency = currencyForLang(lang);
  const locale = currency === "EUR" ? "hr-HR" : "en-US";
  const value = convertPrice(usdAmount || 0, lang);
  return new Intl.NumberFormat(locale, { style: "currency", currency, maximumFractionDigits: 2 }).format(value);
};

export const formatDate = (iso, lang, opts = { dateStyle: "medium" }) => {
  if (!iso) return "";
  const locale = (lang || "en").startsWith("hr") ? "hr-HR" : "en-US";
  try {
    return new Intl.DateTimeFormat(locale, opts).format(new Date(iso));
  } catch {
    return iso;
  }
};

export const formatDateTime = (iso, lang) =>
  formatDate(iso, lang, { dateStyle: "medium", timeStyle: "short" });

export const formatNumber = (n, lang) => {
  const locale = (lang || "en").startsWith("hr") ? "hr-HR" : "en-US";
  return new Intl.NumberFormat(locale).format(n || 0);
};

export const localized = (doc, field, lang) => {
  if (!doc) return "";
  const isHr = (lang || "en").startsWith("hr");
  if (isHr) {
    const hr = doc[`${field}_hr`];
    if (hr && String(hr).trim()) return hr;
  }
  return doc[field] || "";
};

/**
 * Extracts an error code from an axios error response and returns the matching
 * translation key, falling back to the server message or a generic string.
 */
export const apiError = (err, t, fallback = "errors.generic") => {
  const detail = err?.response?.data?.detail;
  if (detail && typeof detail === "object" && detail.code) {
    return t(`errors.${detail.code}`, { defaultValue: detail.message || detail.code });
  }
  if (typeof detail === "string") return detail;
  return t(fallback, { defaultValue: "Something went wrong" });
};
